<template>
    <div class="fs-13 color---gray-500">
        <div class="line-1" v-if="messageType == 'message' || messageType == 'system'">
            {{ message.content.message }}
        </div>
        <div class="line-1 flex row middle" v-else-if="messageType == 'mail'">
            <img class="messageIcon" src="@/assets/emailIcon.png" alt="">
            <span>邮件</span>
        </div>
        <div class="line-1" v-else-if="messageType == 'wink'">👋 Winked</div>
        <div class="line-1 flex row middle" v-else-if="messageType.indexOf('like') != -1">
            <span>👍 赞了 </span>
            <span v-if="messageType.indexOf('photo') != -1">图片</span>
            <span v-else-if="messageType.indexOf('post') != -1">帖子</span>
        </div>
        <div class="line-1" v-else-if="messageType == 'reply_newsfeed_post'">💬回复了帖子</div>
        <div class="line-1" v-else-if="messageType == 'photo' || messageType == 'sticker'">
            <img class="messageImage" :src="message.content.url" alt="">
        </div>
        <div class="line-1 flex row" v-else-if="messageType == 'photo_batch'">
            <template v-for="item in message.content.photos">
                <img class="messageImage mr-4" :src="item.url" alt="">
            </template>
        </div>
        <div class="line-1" v-else-if="messageType == 'video'">
            <i class="el-icon-video-camera messageIcon"></i>
            [视频]
        </div>
        <div class="line-1" v-else-if="messageType == 'audio'">
            <i class="el-icon-video-play messageIcon"></i>
            [音频]
        </div>
        <div class="line-1"
            v-else-if="messageType == 'platform_CorrespondenceLimitChanged' || messageType == 'reaMail' || messageType == 'readMail'">
            阅读了你的邮件
        </div>
        <div class="line-1 color-dating" v-else-if="messageType == 'giftLimit'">
            🎁可以送ta礼物了
        </div>
        <div class="line-1 color-dating" v-else-if="messageType == 'sendNewMessage'">
            可以发送消息
        </div>
        <div class="line-1" v-else>[{{ messageType }}]</div>
    </div>
</template>

<script>
export default {
    name: 'messageFormat',
    props: {
        data: {
            type: Object,
            default: () => { }
        },
        field: {
            type: String,
            default: 'type'
        }
    },
    data() {
        return {
        }
    },
    computed: {
        message() {
            let message = this.data.lastMessage || this.data.lastMessageVo || this.data;
            if (message.pdType == 'mail') {
                message.type = 'mail';
            }
            return message;
        },
        messageType() {
            // console.log('this.message', this.message, this.field);
            const type = this.message[this.field];
            // 如果 type 为 null，尝试使用 pdType
            return type || this.message.pdType;
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
.messageIcon {
    height: 12px;
    width: auto;
    margin-right: 4px;
}

.messageImage {
    width: 36px;
    height: 36px;
    border-radius: 2px;
}
</style>